import script from "./SamlLoginButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SamlLoginButton.vue?vue&type=script&setup=true&lang=ts"

import "./SamlLoginButton.vue?vue&type=style&index=0&id=33473ca9&lang=css"

const __exports__ = script;

export default __exports__